import React from 'react'

export const TwitterIcon = ({ fill }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='16' viewBox='0 0 20 16'>
      <path id='Path_696' data-name='Path 696' d='M1705.29,441a11.5,11.5,0,0,0,11.68-11.495c0-.175-.01-.349-.02-.522a8.136,8.136,0,0,0,2.05-2.092,8.269,8.269,0,0,1-2.36.637,4.08,4.08,0,0,0,1.81-2.235,8.361,8.361,0,0,1-2.61.98,4.146,4.146,0,0,0-5.8-.175,4,4,0,0,0-1.19,3.86,11.732,11.732,0,0,1-8.46-4.22,4.006,4.006,0,0,0,1.27,5.392,4.121,4.121,0,0,1-1.86-.505v.051a4.06,4.06,0,0,0,3.29,3.96,4.144,4.144,0,0,1-1.85.069,4.1,4.1,0,0,0,3.83,2.806,8.316,8.316,0,0,1-6.07,1.674,11.756,11.756,0,0,0,6.29,1.812' transform='translate(-1699 -425)' fill={fill} />
    </svg>
  )
}
